// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IGenerateStatementsDto
 */
export interface IGenerateStatementsDto {
    /**
     * 
     * @type {boolean}
     * @memberof IGenerateStatementsDto
     */
    generate_statements?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IGenerateStatementsDto
     */
    generate_statements_state_id?: IGenerateStatementsDtoGenerateStatementsStateIdEnum;
}

/**
* @export
* @enum {string}
*/
export enum IGenerateStatementsDtoGenerateStatementsStateIdEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IGenerateStatementsDto interface.
 */
export function instanceOfIGenerateStatementsDto(value: object): value is IGenerateStatementsDto {
    return true;
}

export function IGenerateStatementsDtoFromJSON(json: any): IGenerateStatementsDto {
    return IGenerateStatementsDtoFromJSONTyped(json, false);
}

export function IGenerateStatementsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IGenerateStatementsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'generate_statements': json['generate_statements'] == null ? undefined : json['generate_statements'],
        'generate_statements_state_id': json['generate_statements_state_id'] == null ? undefined : json['generate_statements_state_id'],
    };
}

export function IGenerateStatementsDtoToJSON(json: any): IGenerateStatementsDto {
    return IGenerateStatementsDtoToJSONTyped(json, false);
}

export function IGenerateStatementsDtoToJSONTyped(value?: IGenerateStatementsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generate_statements': value['generate_statements'],
        'generate_statements_state_id': value['generate_statements_state_id'],
    };
}

